export const initialHolidayState = {
    holidays: [],
    holidayBookings: [],
};
